export default __webpack_public_path__ + "static/reel-sway-1e39d314ace2971e68bac1a7f80bfe15.mp4";